/* The signature pad (piece 29; decision 2061): a full-width surface a finger or
   a mouse draws on, its strokes never scrolling the page. Every value a token. */
.pad {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.surface {
  display: block;
  width: 100%;
  height: var(--signature-pad-height);
  background: var(--surface);
  border: 1px dashed var(--border);
  border-radius: var(--radius-medium);
  touch-action: none;
  cursor: crosshair;
}

.foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-small);
}
